import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import AccountSettingsOrderConfirmationEmailState from "@tKgpco/Store/Data/AccountSettings/AccountSettingsOrderConfirmationEmailState";
import { Draft } from "immer";

const initialState: AccountSettingsOrderConfirmationEmailState = {};
export const reducer = {
    "Custom/AccountSettings/UpdateAccountSettings": (
        draft: Draft<AccountSettingsOrderConfirmationEmailState>,
        action: { isCheckedForOrderConfirmationEmail: string },
    ) => {
        draft.isCheckedForOrderConfirmationEmail = action.isCheckedForOrderConfirmationEmail;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
